<template>
  <div class="fm-debt-banner">
    <div class="fm-debt-banner__bar">
      <svg class="fm-debt-banner__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
        <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
      </svg>

      <p class="fm-debt-banner__text">
        Borrowing money costs money. Free help is available — call the
        <a href="tel:1800007007">National Debt Helpline on 1800 007 007</a>
        or visit <a href="https://www.moneysmart.gov.au/" target="_blank" rel="noopener">moneysmart.gov.au</a>.
      </p>

      <button
        type="button"
        class="fm-debt-banner__toggle"
        data-toggle="modal"
        data-target="#warningModal"
      >
        Read the full warning
      </button>
    </div>
  </div>
</template>

<script setup>
// Opens the exact same "Warning About Borrowing" modal as the login page
// (resources/views/auth/login.blade.php), via the same jQuery/Bootstrap
// data-toggle/data-target trigger the login page's button uses — no Vue
// modal component here. The modal markup itself now lives in one
// centralised partial (resources/views/sites/includes/warning-about-
// borrowing-modal.blade.php) included by the login page, /new-application,
// and the bought-lead flow, so all three always render the identical
// design instead of separate copies that can drift out of sync.
</script>

<style lang="scss" scoped>
// Colour tokens mirrored from shared/styles/_fm-design-system.scss — kept
// local (rather than importing that partial) so this scoped block doesn't
// re-emit every global .fm-app rule alongside it.
$ink: #15171C;
$amber: #FFB000;

.fm-debt-banner {
  &__bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.75rem;
    background: $ink;
    color: #fff;
    padding: 0.65rem 1.5rem;
  }

  &__icon {
    flex-shrink: 0;
    color: $amber;
  }

  &__text {
    flex: 1 1 auto;
    margin: 0;
    font-size: 13px;
    line-height: 1.4;

    a {
      color: $amber;
      font-weight: 600;
      text-decoration: underline;

      &:hover { color: #fff; }
    }
  }

  &__toggle {
    flex-shrink: 0;
    background: transparent;
    border: 1.5px solid rgba(255, 255, 255, 0.35);
    border-radius: 999px;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    padding: 5px 12px;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
      border-color: #fff;
      background: rgba(255, 255, 255, 0.08);
    }

    &:focus-visible {
      outline: 2px solid $amber;
      outline-offset: 2px;
    }
  }

  @media (max-width: 576px) {
    &__bar {
      padding: 0.65rem 1rem;
    }
  }
}
</style>
